import { apiClient } from '../client';
import { TokenResponseSchema, type TokenResponse, type LoginRequest, type RegisterRequest } from '../types/auth';

export async function login(body: LoginRequest): Promise<TokenResponse> {
  const data = await apiClient.post('auth/login', { json: body }).json();
  return TokenResponseSchema.parse(data);
}

export async function register(body: RegisterRequest): Promise<TokenResponse> {
  const data = await apiClient.post('auth/register', { json: body }).json();
  return TokenResponseSchema.parse(data);
}

export async function logout(refreshToken: string): Promise<void> {
  await apiClient.post('auth/logout', { json: { refreshToken } });
}

export async function refreshToken(token: string): Promise<TokenResponse> {
  const data = await apiClient.post('auth/refresh', { json: { refreshToken: token } }).json();
  return TokenResponseSchema.parse(data);
}

export async function exchangeOAuthCode(code: string): Promise<TokenResponse> {
  const data = await apiClient.post('auth/oauth/exchange', { json: { code } }).json();
  return TokenResponseSchema.parse(data);
}

export async function phoneSendCode(phone: string): Promise<{ message: string; code?: string }> {
  return apiClient.post('auth/phone/send-code', { json: { phone } }).json();
}

export async function phoneVerify(phone: string, code: string): Promise<TokenResponse> {
  const data = await apiClient.post('auth/phone/verify', { json: { phone, code } }).json();
  return TokenResponseSchema.parse(data);
}

export async function sendVerifyEmail(): Promise<{ message: string; code?: string }> {
  return apiClient.post('auth/verify-email/send').json();
}

export async function confirmVerifyEmail(code: string): Promise<{ message: string }> {
  return apiClient.post('auth/verify-email/confirm', { json: { code } }).json();
}

// Link-based verification (preferred; old code-based handlers kept for back-compat).
export async function resendVerificationEmail(email: string): Promise<{ message: string }> {
  return apiClient.post('auth/verification/resend', { json: { email } }).json();
}

export async function enable2FA(): Promise<{ secret: string; message: string }> {
  return apiClient.post('auth/2fa/enable').json();
}

export async function verify2FA(
  code: string,
): Promise<{ message: string; accessToken?: string; refreshToken?: string; user?: { platformRole?: string } }> {
  return apiClient.post('auth/2fa/verify', { json: { code } }).json();
}

export async function disable2FA(): Promise<void> {
  await apiClient.post('auth/2fa/disable');
}
